import { maxInt } from '../helpers';

class Bet {
  constructor(rawObj) {
    this.id = rawObj.id;
    this.idSport = rawObj.sport.id;
    this.name = rawObj.name;
    this.position = parseInt(rawObj.position, 10) || maxInt;
    this.displayIds = rawObj.displayIds;
  }
}

export default Bet;
